import { h } from 'preact';

import Alert from '../../../../../icons/svgo/alert.svg';
import ArrowDown from '../../../../../icons/svgo/arrow-down.svg';
import ArrowLink from '../../../../../icons/svgo/arrow-link.svg';
import ArrowLinkDown from '../../../../../icons/svgo/arrow-link-down.svg';
import ArrowPlayerDx from '../../../../../icons/svgo/arrow-player-dx.svg';
import ArrowPlayerSx from '../../../../../icons/svgo/arrow-player-sx.svg';
import AvatarPlaceholderEmpty from '../../../../../icons/svgo/avatar-placeholder-empty.svg';
import AvatarPlaceholderFilled from '../../../../../icons/svgo/avatar-placeholder-filled.svg';
import Check from '../../../../../icons/svgo/check.svg';
import CheckBox from '../../../../../icons/svgo/checkbox.svg';
import Close from '../../../../../icons/svgo/close.svg';
import Edit from '../../../../../icons/svgo/edit.svg';
import FlagGreen from '../../../../../icons/svgo/flag-green.svg';
import FlagRed from '../../../../../icons/svgo/flag-red.svg';
import Heart from '../../../../../icons/svgo/heart.svg';
import Gallery from '../../../../../icons/svgo/gallery.svg';
import Mail from '../../../../../icons/svgo/mail.svg';
import Padlock from '../../../../../icons/svgo/padlock.svg';
import Pause from '../../../../../icons/svgo/pause.svg';
import Play from '../../../../../icons/svgo/play.svg';
import PlayBlurred from '../../../../../icons/svgo/play-blurred.svg';
import Tick from '../../../../../icons/svgo/tick.svg';
import VideoPlaylist from '../../../../../icons/svgo/video-playlist.svg';
import X from '../../../../../icons/svgo/x.svg';

import Icon from './icon';

export const IconAlert = ({ ...props }) => <Icon {...props} svg={Alert} />;
export const IconArrowDown = ({ ...props }) => <Icon {...props} svg={ArrowDown} />;
export const IconArrowLink = ({ ...props }) => <Icon {...props} svg={ArrowLink} />;
export const IconArrowLinkDown = ({ ...props }) => <Icon {...props} svg={ArrowLinkDown} />;
export const IconArrowPlayerDx = ({ ...props }) => <Icon {...props} svg={ArrowPlayerDx} />;
export const IconArrowPlayerSx = ({ ...props }) => <Icon {...props} svg={ArrowPlayerSx} />;
export const IconAvatarPlaceholderEmpty = ({ ...props }) => <Icon {...props} svg={AvatarPlaceholderEmpty} />;
export const IconAvatarPlaceholderFilled = ({ ...props }) => <Icon {...props} svg={AvatarPlaceholderFilled} />;
export const IconCheck = ({ ...props }) => <Icon {...props} svg={Check} />;
export const IconCheckBoxGreen = ({ ...props }) => <Icon {...props} svg={CheckBox} />;
export const IconClose = ({ ...props }) => <Icon {...props} svg={Close} />;
export const IconEdit = ({ ...props }) => <Icon {...props} svg={Edit} />;
export const IconFlagGreen = ({ ...props }) => <Icon {...props} svg={FlagGreen} />;
export const IconFlagRed = ({ ...props }) => <Icon {...props} svg={FlagRed} />;
export const IconGallery = ({ ...props }) => <Icon {...props} svg={Gallery} />;
export const IconHeart = ({ ...props }) => <Icon {...props} svg={Heart} />;
export const IconMail = ({ ...props }) => <Icon {...props} svg={Mail} />;
export const IconPadlock = ({ ...props }) => <Icon {...props} svg={Padlock} />;
export const IconPause = ({ ...props }) => <Icon {...props} svg={Pause} />;
export const IconPlay = ({ ...props }) => <Icon {...props} svg={Play} />;
export const IconPlayBlurred = ({ ...props }) => <Icon {...props} svg={PlayBlurred} />;
export const IconTick = ({ ...props }) => <Icon {...props} svg={Tick} />;
export const IconVideoPlaylist = ({ ...props }) => <Icon {...props} svg={VideoPlaylist} />;
export const IconX = ({ ...props }) => <Icon {...props} svg={X} />;
